<template>
	<div style="width: 100%">
		<Banner v-if="banner" :banner="banner" />
		<div
			class="session-card__wrapper"
			style="padding: 12px 0"
			v-bind:style="{ marginTop: banner ? '8px' : '0' }"
		>
			<SponsorBadge
				v-if="sponsoredLabel"
				:text="sponsoredLabel"
				:top="'0px'"
				:right="'0px'"
				:icon="'star'"
				:iconSize="10"
				:iconColor="'#ffffff'"
			/>

			<!-- text -->
			<div
				v-if="sessionInfo && sessionInfo.events_agenda_text"
				class="session-card-name mb-3 px-3"
				v-bind:style="{
					paddingTop: sessionInfo.sponsored_by ? '14px' : '0',
				}"
			>
				{{ sessionInfo.events_agenda_text }}
			</div>

			<div
				v-if="sessionInfo && sessionInfo.events_agenda_from && sessionInfo.events_agenda_to"
				class="session-card-date mb-2 px-3 d-flex align-end"
			>
				<Icon :size="16" type="union" :color="'#4a4a4a'" />
				<span class="session-card-date ml-2">
					{{ formatDateDay(sessionInfo.events_agenda_from, sessionInfo.agendaTimezone) }}
					•
					{{ formatTime(sessionInfo.events_agenda_from, sessionInfo.agendaTimezone) }}
					-
					{{ formatTime(sessionInfo.events_agenda_to, sessionInfo.agendaTimezone) }}
					{{ getTimezoneAbbreviation(sessionInfo.agendaTimezone) }}
				</span>
			</div>

			<!-- location -->
			<div
				class="session-card-location mb-2 px-3 cursor-pointer"
				v-if="sessionInfo && sessionInfo.session_location"
				@click="toggleLink(sessionInfo.session_location)"
			>
				<Icon type="pin" :size="16" color="var(--location-color)" :pr="8" />
				{{ sessionInfo.session_location }}
			</div>
			<!--track-->
			<div v-if="sessionInfo && sessionInfo.tracks.length" class="session-card__track px-3">
				<div v-for="track in sessionInfo.tracks" :key="track.track_id">
					<div :style="{ color: track.track_color }" class="session-card__track__name">
						<div
							class="session-card__track__name__circle"
							:style="{ backgroundColor: track.track_color }"
						></div>
						{{ track.track_name }}
					</div>
				</div>
			</div>
      <LinkInfo
          :metadata="metadata"
          v-if="metadata && sessionInfo.agenda_link"
          @toggleLink="toggleLink(sessionInfo.agenda_link)"
          :threadActionTitle="sessionInfo.agenda_title"
      />
			<div
				v-if="registerLimit !== null && sessionInfo && sessionInfo.session_register_link"
				class="session-card__wrapper__progress-container mt-4"
			>
				<span class="session-card__wrapper__progress-container__title">{{
					progressText
				}}</span>
				<v-progress-linear
					height="50"
					rounded
					:color="progressColor"
					:value="(registerCount / registerLimit) * 100"
					background-color="#F3F3F6"
					class="session-card__wrapper__progress-container__progress-bar"
				>
					<span class="session-card__wrapper__progress-container__text"
						>{{ registerCount }} of {{ registerLimit }} seats booked</span
					>
				</v-progress-linear>
			</div>
			<div v-if="sessionInfo && sessionInfo.session_register_link">
				<div
					v-if="sessionInfo.session_register_link.startsWith('https')"
					class="session-card__wrapper__buttons-container mt-3"
				>
					<button
						@click="externalRegisterSession"
						v-if="isRegister === 0 && !isFullyBooked"
						type="button"
						class="session-card__wrapper__buttons-container__register-session-button"
					>
						Register
					</button>
					<button
						v-if="isRegister === 1 || isFullyBooked"
						:disabled="isRegister === 1"
						type="button"
						class="session-card__wrapper__buttons-container__registered-button"
					>
						{{ isFullyBooked ? 'Fully Booked' : 'Registered' }}
					</button>
				</div>
				<div
					v-if="!sessionInfo.session_register_link.startsWith('http')"
					class="session-card__wrapper__buttons-container mt-3"
				>
					<button
						@click="postSessionRegister"
						v-if="isRegister === 0 && !isFullyBooked"
						type="button"
						class="session-card__wrapper__buttons-container__register-session-button"
					>
						Register
					</button>
					<button
						v-if="isRegister === 1 || isFullyBooked"
						type="button"
						:disabled="isFullyBooked"
						:class="
							isFullyBooked
								? 'session-card__wrapper__buttons-container__registered-session-button__fully-booked'
								: 'session-card__wrapper__buttons-container__registered-session-button'
						"
						@click="delRegisterSession"
					>
						{{ isFullyBooked ? 'Fully Booked' : 'Registered' }}
					</button>
				</div>
			</div>
      <div
          v-if="sessionInfo && !sessionInfo.session_register_link && isRegister"
          class="session-card__wrapper__buttons-container">
        <button class="session-card__wrapper__buttons-container__registered-session-button__fully-booked" type="button" disabled>
          Registered
        </button>
      </div>
		</div>
<!--     my agenda button-->
		<div v-if="buttonsBlock && buttonsBlock.schedule" class="session-card__wrapper__button-add-to-sessions" @click="toggleMyAgenda">
			<Icon :type="isScheduled.type" :color="isScheduled.color" :size="24" />
			<span
				class="session-card__wrapper__button-add-to-sessions__title"
				>{{ isScheduled.text }}</span
			>
		</div>
    <div v-if="sessionRestrictedAccess && sessionRestrictedAccess.session_access_text"  class="session-card__restrict">
      <span class="session-card__restrict__text">
        {{sessionRestrictedAccess.session_access_text}}
      </span>
    </div>
		<!--	description	   -->
		<div
			v-if="agendaDetails && agendaDetails.session_description"
			class="session-card__wrapper"
		>
			<span class="session-card-title">Details</span>
			<v-card-text
				ref="contentInner"
				class="event-card__description text-decoration-none"
				v-html="postDescription(description) || ''"
				:class="{ collapsed: !isExpanded && isContentTooLong }"
			/>
			<div v-if="!isExpanded && isContentTooLong" class="fade-overlay"></div>
			<div v-if="isContentTooLong" class="event-card__description__show-more">
				<button @click="toggleExpand">
					{{ isExpanded ? 'Hide' : 'Show More' }}
				</button>
			</div>
		</div>
		<!-- speakers -->
		<div class="session-card__wrapper" v-if="speakers.length > 0">
			<div class="d-flex align-center justify-space-between mb-4">
				<h4 class="session-card-title">Speakers</h4>
				<div class="session-card__link-wrapper">
					<router-link
						:to="{
							name: 'event-session-speakers',
							params: {
								eventId: agendaEvent.events_id,
								sessionId: sessionInfo.events_agenda_id,
							},
						}"
						class="session-card__link pt-2 text-decoration-none"
					>
						<span class="session-card__link-wrapper__title">See All</span>
					</router-link>
				</div>
			</div>

			<router-link
				:to="{
					name: 'speaker-by-id',
					params: { id: +speaker_id },
				}"
				v-for="{
					speaker_logo,
					speaker_name,
					speaker_company,
					speaker_id,
					speaker_title
				} in speakers.slice(0, 5)"
				:key="speaker_id"
				class="session-card-speaker"
			>
				<Avatar class="mr-3 post-preview-card__avatar" :size="50" :avatar="speaker_logo" />
				<div class="session-card__wrapper__speaker-info">
					<h2 v-if="speaker_name" class="session-card-speaker-name">
						{{ speaker_name }}
					</h2>
          <span v-if="speaker_title" class="session-card-speaker-company">
						{{ speaker_title }}
					</span>
					<span v-if="speaker_company" class="session-card-speaker-company">
						{{ speaker_company }}
					</span>
        </div>
			</router-link>
		</div>
		<!--MainSession -->
		<div v-if="isMainSession" class="session-card__wrapper">
			<div class="d-flex align-center justify-space-between mb-4">
				<h4 class="session-card-title">Main Session</h4>
			</div>
			<router-link
				class="text-decoration-none"
				:to="{
					name: 'event-session-by-id',
					params: { id: mainSession.events_agenda_id },
				}"
			>
				<SubSession :agendaEvent="mainSession" />
			</router-link>
		</div>
		<!--	subSession	-->
		<div v-if="subSession && subSession.length" class="session-card__wrapper">
			<div class="d-flex align-center justify-space-between mb-4">
				<h4 class="session-card-title">Sub-Sessions</h4>
				<div class="session-card__link-wrapper">
					<router-link
						:to="{
							name: 'sub-session-list',
							query: {
								events_agenda_id: sessionInfo.events_agenda_id,
							},
						}"
						class="session-card__link pt-2 text-decoration-none"
					>
						<span class="session-card__link-wrapper__title">See All</span>
					</router-link>
				</div>
			</div>
			<div v-for="sub in subSession" :key="sub.events_agenda_id">
				<router-link
					:to="{
						name: 'event-session-by-id',
						params: { id: sub.events_agenda_id },
					}"
					class="d-flex text-decoration-none"
					style="width: 100%"
				>
					<SubSession :agendaEvent="sub" />
				</router-link>
			</div>
		</div>
		<div v-if="additionalInfo && additionalInfo.sessionActions" class="session-card__wrapper">
			<div class="session-card__wrapper__useful">
				<span class="session-card__wrapper__useful__title">Additional Info</span>
				<div>
					<div class="event-card__event-actions mt-3">
						<ActionPreview
							v-for="(action, index) in this.additionalInfo.sessionActions"
							:key="index"
							class="event-card__event-actions__event-wrapper"
							:action="action"
							:event-id="sessionInfo.events_agenda_id"
							@click.native="handleEventActionClick(action, $event)"
						>
							<div class="event-card__action-wrapper u-cursor-pointer">
								<Icon
									:type="getAction(action).icon"
									color="var(--button-icon-tint)"
									:size="24"
								/>
							</div>
							<div class="event-card__event-actions__title u-cursor-pointer text-decoration-none">
								{{ getAction(action).name }}
							</div>
						</ActionPreview>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isFeedBackVisible" class="event-card__section">
			<h4 class="event-card__section-title mb-3">Feedback</h4>
			<div class="event-card__section__feedback">
				<button
					v-if="feedbackSection.qa && feedbackSection.qa.qna_id"
					@click="
						toggleToQaNa(
							feedbackSection.qa.qna_id,
							feedbackSection.qa.qna_entity_id,
							feedbackSection.qa.qna_entity_type,
							feedbackSection.qa.qna_allow_anonymous
						)
					"
					type="button"
					class="event-card__section__feedback__button-survey cursor-pointer"
				>
					<Icon type="question" :size="24" color="var(--button-icon-tint)" />
					<span class="event-card__section__feedback__button-survey__text">{{
						feedbackSection.qa.button_name
					}}</span>
				</button>
				<button
					v-if="feedbackSection.surveys"
					@click="
						toggleToSurvey(
							feedbackSection.surveys.survey_id,
							feedbackSection.surveys.survey_type
						)
					"
					type="button"
					class="event-card__section__feedback__button-survey"
				>
					<CustomCheckbox
						v-if="feedbackSection.surveys.is_complete"
						:checkRadius="10"
						:isChecked="!!feedbackSection.surveys.is_complete"
						class="event-card__section__feedback__button-survey__checkbox"
					/>
					<Icon
						type="task-list"
						:size="24"
						:color="
							feedbackSection.surveys.is_complete
								? '#9b9b9b'
								: 'var(--button-icon-tint)'
						"
					/>
					<span
						:style="{
							color: feedbackSection.surveys.is_complete
								? '#9b9b9b'
								: 'var(--username-category-title)',
						}"
						class="event-card__section__feedback__button-survey__text"
						>{{ feedbackSection.surveys.button_name }}</span
					>
				</button>
			</div>
			<div v-if="feedbackSection.rating" class="event-card__section__ratings mt-2">
				<Rating :rating="feedbackSection.rating" />
			</div>
		</div>
    <InfoModal
        :isModal="isModal"
        @closeModal="closeModal"
        :isCompleted="true"
    />
		<v-dialog
			v-model="mobileLink"
			class="exhibitor-page__modal"
			max-width="588px"
			width="100%"
			persistent
		>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">
					This screen is not available in the Web App, but you can access it through the
					mobile app
				</div>
				<button
					type="button"
					@click="toggleCloseMobileLink"
					class="exhibitor-page__modal__btn"
				>
					OK
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'
import SessionAttachments from '@/components/Resource/SessionAttachments.vue'
import Poll from '@/components/Post/Poll'
import Rating from '@/components/Event/Rating'
import Banner from '@/components/Banner'
import { mapActions, mapGetters } from 'vuex'
import PollEvent from '@/components/Post/PollEvent.vue'
import ActionPreview from '@/components/Event/Action/ActionPreview.vue'
import linkifyThreadText from '@/mixins/linkifyThreadText'
import SponsorBadge from '@/components/SponsorBadge.vue'
import SubSession from '@/components/Event/SubSession.vue'
import CustomCheckbox from '@/components/CustomCheckbox.vue'
import LinkInfo from "@/components/LinkInfo.vue"
import InfoModal from "@/components/Modals/InfoModal.vue";

Vue.use(VueScrollTo)

export default {
	name: 'SessionCard',
	components: {
    InfoModal,
		CustomCheckbox,
		SponsorBadge,
		SessionAttachments,
		Avatar,
		Poll,
		Rating,
		Banner,
		PollEvent,
		ActionPreview,
		SubSession,
    LinkInfo
	},
	mixins: [linkifyThreadText],
	props: {
		agendaEvent: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			mobileLink: false,
			polls_answers: [],
			rating_answers: [],
			isRegister: 0,
			registerCount: null,
			registerLimit: null,
			metadata: null,
			isContentTooLong: false,
			isExpanded: false,
			description: '',
			pendingScheduled: null,
      isModal:false
		}
	},
	watch: {
		agendaEvent: {
			handler(newVal) {
				if (newVal) {
					this.isRegister = this.sessionInfo.is_registered
					this.registerLimit = this.sessionInfo.session_limited
					this.registerCount = this.sessionInfo.registered_count
				}
			},
			deep: true,
			immediate: true,
		},
		'agendaEvent.agenda_link': {
			handler(newVal) {
				if (newVal) {
					this.fetchMetadata()
				}
			},
			immediate: false,
		},
		'agendaDetails.session_description'(val) {
			if (val) {
				this.$nextTick(this.checkContentHeight)
			}
		},
		description(val) {
			if (val) {
				this.$nextTick(() => {
					this.parseDescription()
					this.checkContentHeight()
				})
			}
		},
	},
	mounted() {
		if (this.sessionInfo && this.sessionInfo.agenda_link) {
			this.fetchMetadata()
		}
		this.$nextTick(() => {
			this.checkContentHeight()
		})
	},
	created() {
		if (this.agendaDetails && this.agendaDetails.session_description) {
			this.parseDescription()
		}
	},

	methods: {
		...mapActions('event', [
			'addMyAgenda',
			'removeMyAgenda',
			'voteEventPolls',
			'voteSessionRatings',
			'postRegisterSession',
			'deleteRegisterSessions',
      'getSession'
		]),
    ...mapActions('auth', ['showAlert']),
    closeModal(){
      this.isModal = false
    },
		toggleToSurvey(id, type) {
      if(this.feedbackSection.surveys.is_complete){
        return this.isModal = true
      }
			this.$router.push({
				name: 'survey',
				params: {
					id: id,
				},
				query: {
					type: type,
					session_id: this.$route.params.id,
					from: 'session',
				},
			})
		},
		toggleToQaNa(id, qna_entity_id, qna_entity_type, qna_allow_anonymous) {
			this.$router.push({
				name: 'event-session-questions',
				query: {
					qna_id: id,
					qna_entity_id: qna_entity_id,
					qna_entity_type: qna_entity_type,
					qna: qna_allow_anonymous ? 1 : 0,
				},
			})
		},
		getBlockData(name, fallback = undefined) {
			const block = (this.agendaEvent.sessionView || []).find((b) => b.block_name === name)
			return block ? block.block_data : fallback
		},
		formatDateDay(timestamp, timezone) {
			const date = new Date(timestamp * 1000)
			const offset = Number(timezone.timezone_utc.slice(-2))
			const sign = timezone.timezone_utc.slice(3, 4)

			if (sign === '-') {
				date.setHours(date.getHours() - offset)
			} else {
				date.setHours(date.getHours() + offset)
			}
			return date.toLocaleDateString('en-US', {
				weekday: 'short',
				month: 'short',
				day: 'numeric',
			})
		},
		formatTime(timestamp, timezone) {
			const options = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: true,
				timeZone: 'UTC',
			}

			const date = new Date(timestamp * 1000)
			const offset = Number(timezone.timezone_utc.slice(-2))
			const sign = timezone.timezone_utc.slice(3, 4)

			if (sign === '-') {
				date.setHours(date.getHours() - offset)
			} else {
				date.setHours(date.getHours() + offset)
			}

			return date.toLocaleTimeString('en-US', options)
		},
		getTimezoneAbbreviation(timezone) {
			return timezone.timezone_code || 'UTC'
		},
		parseDescription() {
			const parser = new DOMParser()
			const doc = parser.parseFromString(this.agendaDetails.session_description, 'text/html')
			this.description = doc.body.innerHTML
		},
		toggleCloseMobileLink() {
			this.mobileLink = false
		},
		async toggleLink(link) {
			const target = link

			if (!target || typeof target !== 'string') return
			if (!/^https?:\/\//i.test(target)) return

			if (this.isUnsupportedDeepLink(target)) {
				this.mobileLink = true
				return
			}
			if (this.isMapUrlValid(target)) {
				try {
					await this.getMapRegisterToken()
					if (!this.mapRegisterToken) {
						console.error('Token not received')
						return
					}

					const urlWithToken = `${target}${target.includes('?') ? '&' : '?'}code=${
						this.mapRegisterToken
					}`
					window.open(urlWithToken, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(target, '_self')
			}
		},
		async handleEventActionClick(eventAction, event) {
			if (eventAction.action_type === 'link' || eventAction.action_type === 'map') {
				try {
					await this.toggleLink(eventAction.action_value)
					return
				} catch (e) {
					console.error(e)
				}
			}
			if (eventAction.action_type === 'deepLink') {
				const restrictedLinks = [
					'live-events',
					'event-manager',
					'higher-logic',
					'gamification',
				]
				const lowerCaseLink = eventAction.action_value.toLowerCase()
				const isRestricted = restrictedLinks.some((restricted) =>
					lowerCaseLink.includes(restricted)
				)

				if (isRestricted) {
					if (event) {
						event.preventDefault()
						event.stopPropagation()
					}
					this.mobileLink = true
					return
				} else {
					const target = this.transformDeepLink(eventAction.action_value)
					window.open(target, '_self')
					return
				}
			}
		},
		getAction(action) {
			let icons = {
				link: 'link',
				email: 'email',
				phone: 'phone',
				grid: 'phone_empty',
				fileList: 'folder',
				linkList: 'list',
				deepLink: 'link',
				grid2: 'IconGrid2',
				map: 'location',
			}
			return {
				icon: icons[action.action_type],
				link:
					action.action_type !== '' && action.action_type !== ''
						? action.action_value
						: null,
				name: action.action_name,
				color: action.button_color,
			}
		},
		transformDeepLink(link) {
			const match = link.match(/:\/\/(.*)/)
			return match ? `${window.location.origin}/webapp/${match[1]}` : link
		},
		toggleExpand() {
			this.isExpanded = !this.isExpanded
		},
		checkContentHeight() {
			const contentEl = this.$refs.contentInner
			if (contentEl) {
				const lineHeight = parseFloat(window.getComputedStyle(contentEl).lineHeight)
				const height = contentEl.scrollHeight
				const numLines = Math.floor(height / lineHeight)
				this.isContentTooLong = numLines > 5
			}
		},
		async fetchMetadata() {
			try {
				const response = await fetch(this.sessionInfo.agenda_link, {
					mode: 'cors',
				})
				const html = await response.text()

				const parser = new DOMParser()
				const doc = parser.parseFromString(html, 'text/html')

				this.metadata = {
					description:
						doc.querySelector("meta[property='og:description']")?.content ||
						this.getDisplayLink(this.sessionInfo.agenda_link),
					image: doc.querySelector("meta[property='og:image']")?.content || null,
					url: this.agendaEvent.agenda_link,
				}
			} catch (error) {
				console.error(error)
				this.metadata = {
					description: this.getDisplayLink(this.sessionInfo.agenda_link),
					image: null,
					url: this.sessionInfo.agenda_link,
				}
			}
		},
		getDisplayLink(rawLink) {
			if (!rawLink) {
				return ''
			}
			if (rawLink.startsWith('com.pinxterapp.dev.clowder-core://')) {
				return window.location.origin
			}
			try {
				const urlObj = new URL(rawLink)
				let domain = urlObj.hostname
				if (!domain.startsWith('www.')) {
					domain = 'www.' + domain
				}
				return domain
			} catch (error) {
				return rawLink
			}
		},
		externalRegisterSession() {
			window.location.href = this.sessionInfo.session_register_link
		},
    sessionReload(){
      this.$emit('sessionReload')
    },
		async postSessionRegister() {
			if (this.registerCount < this.registerLimit || this.registerLimit === null) {
        try {
          await this.postRegisterSession({
            session_id: this.sessionInfo.events_agenda_id,
            user_id: this.profile.user_id,
            description: null,
          })
        } catch (e){
          console.log(e)
          const errorMsg =
              e.response?.data?.message ||
              e.response?.data?.[0]?.message ||
              e?.message ||
              'Failed to register session'
          this.showAlert({ message: errorMsg, type: 'error' })
          setTimeout(() => {
            this.sessionReload()
          }, 2000)
          return
        }

        this.isRegister = 1
        this.registerCount++
        if(this.sessionRestrictedAccess && this.sessionRestrictedAccess.session_restricted_access === 1){
        this.sessionReload()
        }
			}
		},

		async delRegisterSession() {
			if (this.registerCount > 0 || this.registerLimit === null) {
				this.isRegister = 0
				this.registerCount--
				await this.deleteRegisterSessions(this.sessionInfo.events_agenda_id, {
					session_id: this.sessionInfo.events_agenda_id,
					user_id: this.profile.user_id,
					description: null,
				})
			}
		},

		async toggleMyAgenda() {
			if (this.isMyAgendaLoading) return

			const id = this.sessionInfo.events_agenda_id

			if (this.computedIsScheduled) {
				this.pendingScheduled = false
				await this.removeMyAgenda({ id, myAgenda: false, single: true })
			} else {
				this.pendingScheduled = true
				await this.addMyAgenda({ id, single: true })
			}
		},
	},
	computed: {
		...mapGetters('event', [
			'isMyAgendaLoading',
			'pollsLoading',
			'ratingsLoading',
			'isLoading',
		]),
		...mapGetters('advertisement', ['banner']),
		...mapGetters('auth', {
			profile: 'profile',
			isAuthenticated: 'isAuthenticated',
			authIsLoading: 'isLoading',
		}),
    sessionRestrictedAccess(){
      return this.getBlockData('sessionRestrictedAccess', {})
    },
		subSession() {
			return this.getBlockData('subSessions', [])
		},
		mainSession() {
			return this.getBlockData('mainSession', {})
		},
		sessionInfo() {
			return this.getBlockData('sessionInfo', {})
		},
		agendaDetails() {
			return this.getBlockData('details', {})
		},
		speakers() {
			const res = this.getBlockData('speakers', [])
			return Array.isArray(res) ? res : []
		},
		additionalInfo() {
			return this.getBlockData('additionalInfo', {})
		},
		feedbackSection() {
			return this.getBlockData('feedback', {})
		},
    buttonsBlock() {
      return this.getBlockData('buttons', {})
    },

    isFullyBooked() {
			return this.registerLimit === this.registerCount && this.isRegister === 0
		},
		isFeedBackVisible() {
			return (
				this.feedbackSection &&
				(this.feedbackSection.rating ||
					(this.feedbackSection.qa && this.feedbackSection.qa.qna_id) ||
					(this.feedbackSection.surveys && this.feedbackSection.surveys.survey_id))
			)
		},
    isMainSession() {
      return this.mainSession && this.mainSession.events_agenda_id
    },
		progressText() {
			const percentage = (this.registerCount / this.registerLimit) * 100
			if (percentage >= 100) {
				return 'Limited Seats!'
			} else if (percentage >= 81) {
				return 'Register Now – Limited Seats!'
			} else {
				return "Secure your spot before it's gone!"
			}
		},
		progressColor() {
			const percentage = (this.registerCount / this.registerLimit) * 100
			if (percentage >= 100) {
        if(this.isRegister === 1) {
          return 'rgba(16, 196, 145, 0.3)'
        } else {
          return 'rgba(255, 59, 48, 0.3)'
        }
      } else if (percentage >= 81) {
				return 'rgba(236, 149, 47, 0.3)'
			} else {
				return 'rgba(16, 196, 145, 0.3)'
			}
		},

		polls() {
			if (!this.agendaEvent || !Array.isArray(this.agendaEvent.polls)) return []
			return this.agendaEvent.polls.filter(
				(poll) =>
					poll.pollsAnswers.length ||
					(!poll.pollsAnswers.length && poll.allow_custom_answer)
			)
		},
		sponsoredLabel() {
			return this.sessionInfo && this.sessionInfo.sponsored_by
				? `Sponsored by ${this.sessionInfo.sponsored_by}`
				: ''
		},
		computedIsScheduled() {
			if (this.pendingScheduled !== null) {
				return this.pendingScheduled
			}
			return !!this.buttonsBlock.schedule?.is_scheduled
		},
		isScheduled() {
			return this.computedIsScheduled
				? {
						text: 'Remove Session',
						color: 'var(--button-icon-tint)',
						type: 'remove_schedule',
				  }
				: {
						text: 'Add Session',
						color: 'var(--button-icon-tint)',
						type: 'add_schedule',
				  }
		},
	},
}
</script>

<style lang="scss">
.session-card {
	font-family: Inter, sans-serif;
  &__restrict{
    display: flex;
    align-items: center;
    justify-content: center;
    &__text{
      margin-top: 121px;
      max-width: 257px;
      text-align: center;
      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0;
      color: var(--accent-color);


    }
  }
  &-name{
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: 0;
    color: var(--username-category-title);

  }
	&__track {
		&__name {
			display: flex;
			align-items: center;
			gap: 8px;
			font-weight: 700;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			padding: 3px;

			&__circle {
				width: 10px;
				height: 10px;
				border-radius: 50%;
			}
		}
	}
	&__wrapper {
		position: relative;
		background-color: #fff;
		padding: 12px 12px;
		border-radius: 8px;
		margin-bottom: 8px;
		border: 1px solid #e2e2e2;
		&__speaker-info {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			min-height: 55px;
		}
		&__button-add-to-sessions {
			width: 100%;
			height: 75px;
			background-color: #ffffff;
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			margin-bottom: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			flex-direction: column;
			&__title {
				font-family: 'Inter', sans-serif;
				font-weight: 500;
				font-size: 16px;
				line-height: 100%;
				letter-spacing: 0;
				color: var(--username-category-title);
				margin-top: 8px;
			}
		}
		&__useful {
			&__title {
				font-family: Inter, sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
			}
			&__info-container {
				&__section {
					display: flex;
					align-items: center;
					max-width: 261px;
					width: 100%;
					padding: 8px;
					background-color: #f3f3f6;
					border-radius: 8px;
					&__title {
						font-family: Inter, sans-serif;
						font-weight: 400;
						font-size: 16px;
						line-height: 100%;
						letter-spacing: 0;
						color: #4a4a4a !important;
						margin-left: 8px;
					}
				}
			}
		}
		&__progress-container {
			width: 100%;
			padding: 0 16px;
			display: flex;
			flex-direction: column;
			align-items: center;
			&__title {
				font-family: 'Inter', sans-serif;
				font-weight: 600;
				font-size: 14px;
				color: var(--accent-color);
				line-height: 22px;
				margin-bottom: 8px;
			}
			&__progress-bar {
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&__text {
				position: absolute;
				width: 100%;
				text-align: center;
				font-family: 'Inter', sans-serif;
				font-weight: 600;
				font-size: 16px;
				color: #002855;
			}
		}
		&__buttons-container {
			width: 100%;
			padding: 12px 12px 0 12px;
			border-top: 1.5px solid #e2e2e2;
			display: flex;
			justify-content: center;
			&__registered-button {
				width: 100%;
				height: 50px;
				border-radius: 8px;
				align-items: center;
				border: 2px solid #9b9b9b;
				color: #697583;
				font-family: 'Inter', sans-serif;
				font-size: 18px;
				font-weight: 700;
				line-height: 100%;
			}
			&__register-session-button {
				width: 100%;
				height: 50px;
				border-radius: 8px;
				align-items: center;
				background-color: var(--button-main-background-color);
				color: var(--button-main-color);
				font-family: 'Inter', sans-serif;
				font-size: 18px;
				font-weight: 700;
				line-height: 100%;
			}
			&__registered-session-button {
				width: 100%;
				height: 50px;
				border-radius: 8px;
				align-items: center;
				border: 2px solid var(--button-secondary-background-color);
				color: var(--button-secondary-background-color);
				font-family: 'Inter', sans-serif;
				font-size: 18px;
				font-weight: 700;
				line-height: 100%;
				&__fully-booked {
					width: 100%;
					height: 50px;
					border-radius: 8px;
					align-items: center;
					border: 2px solid #9b9b9b;
					color: #9b9b9b;
					font-family: 'Inter', sans-serif;
					font-size: 18px;
					font-weight: 700;
					line-height: 100%;
				}
			}
		}
	}

	&-date {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}

	&-title {
		color: #4a4a4a;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 18px;
		line-height: 22px;
		letter-spacing: 0;
	}

	&-text {
		color: var(--accent-color);
		font-size: 14px;
		line-height: 17.07px;

		p {
			margin: 0;
		}
	}

	&-tag {
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 700;
		line-height: 19.37px;
	}

	&-location {
		display: flex;
		align-items: center;
		color: var(--location-color);
		font-size: 13px;
		font-weight: 500;
		line-height: 100%;
	}

	&-speaker {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		text-decoration: none;
		background-color: #f3f3f6;
		padding: 12px;
		border-radius: 8px;

		&:not(:last-child) {
			margin-bottom: 8px;
		}

		&-name {
			color: var(--username-category-title);
			margin-bottom: 4px !important;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
		}
		&-company {
			color: var(--company-position-large);
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
      margin-top: 2px;
		}
		&-title {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a !important;
			margin-top: 4px;
		}
	}

	&__link {
		font-size: 14px;
		font-weight: 700;
		line-height: 17.07px;
		color: var(--text_button_tint) !important;

		&-wrapper {
			display: flex;
			justify-content: center;
			&__title {
				font-family: 'Inter', sans-serif;
				font-weight: 700;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				text-align: center;
			}
		}
	}

	&__button {
		color: var(--button-main-background-color) !important;
		background-color: transparent !important;
		text-transform: capitalize;
		text-decoration: none;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: center;
	}

	&-registered {
		padding: 0 30px;

		&-chip {
			height: 23px !important;
			font-size: 12px !important;
			line-height: 14.63px;
			font-weight: 700;
			background-color: var(--accent-color) !important;
			color: #fff !important;
		}
	}

	&-add-my-agenda {
		&-wrapper {
			padding: 20px 16px 4px 16px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		&-btn {
			text-transform: none;
			font-size: 14px;
			font-weight: 700;
			line-height: 17.07px;
			color: #0055a3;
			background-color: transparent !important;
			padding: 0 8px !important;

			&-text {
				text-decoration: underline;
			}
		}
	}

	&__add-question-btn,
	&__add-question-btn-view {
		background: var(--button-main-background-color) !important;
		color: var(--button-main-color) !important;
		text-transform: capitalize;
		font-size: 16px !important;
		font-weight: 700;
	}

	&__add-question-btn-view {
		color: var(--accent-color) !important;
		background: transparent !important;
	}

	&__question {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		justify-content: space-between;
		padding: 12px;
		background-color: #f3f3f6;
		border-radius: 8px;
		height: 58px;
		width: 100%;

		&:not(:last-child) {
			margin-bottom: 8px;
		}

		&-text {
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--accent-color);
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		&-count {
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			color: #697583;

			&-active {
				color: var(--button-main-background-color);
			}
		}
	}
}

.file_box {
	background: #f3f3f6;
	padding: 12px;
	border-radius: 12px;
	gap: 12px;
}
.event-card__description.collapsed {
	display: -webkit-box;
	-webkit-line-clamp: 5;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.fade-overlay {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 30px;
	pointer-events: none;
	z-index: 0;
}
</style>
